import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";


export const LectureContainer = styled.div`
    margin-top: 1rem;
    height:100%;
    width:100%;
    display: flex;
    flex-direction: column;
    gap:10px;
    
    overflow-y: auto ;
`;

export const LectureItems = styled.div`
    width:100%;
    display: flex;
    flex-direction: column;
    padding-right: 4px;
    gap:10px;
    z-index: 1;
    padding-bottom: 5px;
    scrollbar-width: thin;
    position: relative;
    overflow-y: auto ;
    
    ::-webkit-scrollbar{
        width:8px;
        height:100%;
        background:#dfdfdf4e;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb{
        background:#dfdfdf;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track{
        
    } 
    
`;

export const SelectAll = styled.button<{selected?:boolean}>`
    padding:6px 0;
    border-radius: 5px;
    border: 1px solid ${props => props.theme.colors.placeholderColor};
    font-size: 14px;
    font-weight: 500;
    background: ${props => props.selected?props.theme.colors.placeholderColor:"#fff"};
    box-shadow: 0 2px 1px 0 rgba(0,0,0,0.1);
    transition: all 0.1s ease-in-out;
    color: ${props => props.selected?"#fff":props.theme.colors.placeholderColor};
   

    :hover{
        background: ${props => props.theme.colors.placeholderColor};
        color: #fff;
    }
`;


export const DateSelectContainer = styled.div<{ span?: boolean }>`
    width:100%;
    display:flex;
    align-items: center;
    gap:10px;
    position: relative;

    >div:nth-of-type(2),>div:nth-of-type(1){
        grid-column: ${props => props.span ? "2 / span 2" : "unset"};
        width: ${props => props.span ? "50%" : "unset"};
    }
`;

export const DateSelectRow = styled.div`
    display:flex;
    align-items:center;
`;

export const DateSelector = styled.div`
    height:28px;
    border:1px solid #2A848E;
    border-radius: 5px;
    display:flex;
    align-items:center;
    gap:8px;
    padding:0 12px;

    span{
        color:#2A848E;
        font-size: 14px;
        font-weight: 600;
    }

    svg{
        margin-left: auto;
        height:80%;
    }
`;


export const SubTitle = styled.span`
    font-size: 16px;
    font-weight: 500;
    margin-right: auto;

`;